import {css} from '@emotion/react';
import styled from '@emotion/styled';

import {RatingSnippet} from '@/components/RatingSnippet';

type Props = {
  isCompact?: boolean;
};

export const Container = styled.div<Props>(
  ({theme, isCompact}) => css`
    position: relative;

    ${isCompact &&
    css`
      height: 200px;
      width: 100%;

      @supports (aspect-ratio: 1) {
        height: auto;
        width: auto;
        aspect-ratio: 16 / 9;
      }
    `}

    ${RatingSnippet} {
      /* @TODO add to shared component in library */
      box-sizing: border-box;
      width: 100%;
      padding: 16px;
      /* @TODO add to shared component in library */
      justify-content: start;
      background: linear-gradient(
        to top,
        ${theme.colors.backgroundOverlay},
        transparent
      );
    }
  `
);
